export const REGION_VARIANTS = {
  EU: 'eu',
  US: 'us',
} as const;
export type TRegionVariant =
  (typeof REGION_VARIANTS)[keyof typeof REGION_VARIANTS];
